import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';

const PAGE_OF_TASK_ROLE_OPTIONS_QUERY = gql`
  query GetPageOfTaskRoleOptions(
    $taskId: String!
    $page: Int!
    $pageSize: Int!
    $textSearch: String
  ) {
    task(taskId: $taskId) {
      id
      pageOfTaskRoleOptions(
        page: $page
        pageSize: $pageSize
        textSearch: $textSearch
      ) {
        roles {
          projectRole {
            id
            displayText
          }
          isAssigned
          isDefault
        }
        hasMore
      }
    }
  }
`;

const usePageOfTaskRoleOptions = ({
  taskUri,
  page,
  pageSize,
  textSearch,
  skip = false
}) => {
  const { data, loading } = useQuery(PAGE_OF_TASK_ROLE_OPTIONS_QUERY, {
    variables: {
      taskId: taskUri,
      page,
      pageSize,
      textSearch: textSearch || null
    },
    skip: skip || !taskUri,
    fetchPolicy: 'cache-and-network'
  });

  const pageOfTaskRoleOptions = data?.task?.pageOfTaskRoleOptions;
  const options = pageOfTaskRoleOptions?.roles;

  const roles = useMemo(
    () =>
      (options ?? []).map(({ projectRole, isAssigned }) => ({
        roleUri: projectRole.id,
        displayText: projectRole.displayText,
        isAssigned
      })),
    [options]
  );

  return {
    roles,
    hasMore: pageOfTaskRoleOptions?.hasMore ?? false,
    loading
  };
};

export default usePageOfTaskRoleOptions;
